import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {useState, useEffect, forwardRef, useImperativeHandle } from 'react';
import {API_URL} from '../index';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import ButtonGroup from '@material-ui/core/ButtonGroup';
import Button from '@material-ui/core/Button';
import Divider from '@material-ui/core/Divider';
import Organisation from './Organisation'

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    marginTop: theme.spacing(3),
    overflowX: 'auto',
  },
  table: {
    minWidth: 650,
  },
}));

const SearchResults = forwardRef((props, ref) => {

  const classes = useStyles();

  const [organisations, setOrganisations] = useState();
  const [fetching, setFetching] = useState();
  const [page, setPage] = useState(props.page);

  useEffect(() => {
      setOrganisations(props.result);
  }, []);


  const loadOrganisationList = (page) => {
      const token = localStorage.getItem('token') != null ? 'Token ' + localStorage.getItem('token') : ''
      setFetching(true)
      const organisation_url = page
        fetch(organisation_url, {
          method: 'GET',
          headers: { 'Content-Type': 'application/json', 'Authorization': token }
        })
        .then(response => {setPage(response.url); return response.json()})
        .then(data => setOrganisations(data))
        .then(e => setFetching(false))
  }

  useImperativeHandle(ref, () => ({
    update() {
          const token = localStorage.getItem('token') != null ? 'Token ' + localStorage.getItem('token') : ''
          setFetching(true)
          const organisation_url = API_URL + 'organisations/'
            fetch(organisation_url, {
              method: 'GET',
              headers: { 'Content-Type': 'application/json', 'Authorization': token }
            })
            .then(response => {setPage(response.url); return response.json()})
            .then(data => setOrganisations(data))
            .then(e => setFetching(false))
    }
  }));

  return (
    <React.Fragment>
    { organisations != undefined ?
    <div>
    <Typography component="p" align='left'>Найдено организаций: <b style={{color: "#800080"}}>{ organisations.count }</b></Typography>
    <Divider orientation='horizontal' />
    <Paper className={classes.root}>
      <Table className={classes.table} size='small'>
        <TableHead>
          <TableRow style={{backgroundColor: '#4c5866'}}>
            <TableCell align="right" style={{color: '#f0f8ff'}}>ID</TableCell>
            <TableCell style={{color: '#f0f8ff'}}>Наименование организации</TableCell>
            <TableCell align="right" style={{color: '#f0f8ff'}}></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {organisations.results.map(organisation => (
            <TableRow key={organisation.id} hover style={{backgroundColor: organisation.is_open ? '' : '#ffcabd'}}>
              <TableCell align="right">{organisation.id}</TableCell>
              <TableCell component="th" scope="row">
                {organisation.title} <u><i style={{color: '#4b0082'}}>{organisation.archive_fund != null ? organisation.archive_fund : ''}</i></u>
              </TableCell>
              <TableCell align="right">
              <Organisation organisation={organisation} user={props.user} archive={props.archive} refresh={e => loadOrganisationList(page)} />
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
        <br/>
            <ButtonGroup size="small" aria-label="small outlined button group">
              {organisations.previous === null ?
              <Button disabled>Предыдущая</Button> :
              <Button onClick={e => loadOrganisationList(organisations.previous)}>Предыдущая</Button>}
              {organisations.next === null ?
              <Button disabled>Следующая</Button> :
              <Button onClick={e => loadOrganisationList(organisations.next)}>Следующая</Button>}
            </ButtonGroup>
            <h4>Всего страниц: { (organisations.count - organisations.count % 10) / 10 + 1 } </h4>
    </Paper>
    </div>
    :
    <div></div>
    }
    </React.Fragment>
  );
})

export default SearchResults;